import { render } from "./OfertasView.vue?vue&type=template&id=466315fe&scoped=true"
import script from "./OfertasView.vue?vue&type=script&lang=js"
export * from "./OfertasView.vue?vue&type=script&lang=js"

import "./OfertasView.vue?vue&type=style&index=0&id=466315fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466315fe"]])

export default __exports__